<template>
    <div>
        <b-modal id="modal-Admins" class="modal-form" :title="modal_title" @hidden="CLEAR_FORM()" centered hide-footer>
            <ValidationObserver ref="form">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Name</label>
                        <input v-model="formdata.name" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required|email" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Email</label>
                        <input v-model="formdata.email" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider v-if="!formdata.id" name="confirm" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <div class="d-block">
                            <label for="password" class="control-label">Password</label>
                        </div>
                        <input id="password" type="password" v-model="formdata.password" class="form-control" name="password">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider v-if="formdata.id" name="confirm" v-slot="{ errors }">
                    <div class="form-group">
                        <div class="d-block">
                            <label for="password" class="control-label">Password</label>
                        </div>
                        <input id="password" type="password" v-model="formdata.password" class="form-control" name="password2">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required|password:@confirm" v-slot="{ errors }" v-if="formdata.password !== ''">
                    <div class="form-group">
                        <div class="d-block">
                            <label for="confirm" class="control-label">Password Confirmation</label>
                        </div>
                        <input id="confirm" type="password" v-model="formdata.confirmation" class="form-control" name="confirm">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
        
                <div class="button-modal text-right">
                    <button v-on:click="validationForm(formdata.id)" type="button" class="btn btn-new"  v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
        <b-modal id="modal-Status" centered hide-footer hide-header>
            <form>
                <div class="form-group">
                    <label class="mb-2">Status Admin</label>
                    <div class="input-group">
                        <select class="form-control" v-model="status">
                            <option value="true">Active</option>
                            <option value="false">Not Active</option>
                        </select>
                    </div>
                </div>
            </form>
            <div class="text-right">
                <button v-on:click="_changeStatus()" type="button" class="btn btn-new"  v-bind:class="loading ? 'btn-progress' : ''">
                    Change Status
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver, extend} from "vee-validate";

    extend('password', {
        params: ['target'],
        validate(value, { target }) {
            return value === target;
        },
        message: 'Confirmation Password Not Same'
    });

    export default{
        data(){
            return{
                loading:false,
                modal_title : 'Add Admin',
                status:''
            }
        },
        props: ['del_admins'],
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        computed: {
            ...mapState('AdminsControl', {
                formdata: state => state.formdata,
                errors: state => state.errors
            }),
        },
        watch:{
            'formdata':function(val){
                if(val.id){
                    this.modal_title = 'Edit Admin'
                }else if(!val.id){
                    this.modal_title = "Add Admin"
                }
            },
            errors:function(val){
                if(val.email){
                    this.$toast.warning('Your email already exists')
                    this.loading = false
                }
            }
        },
        methods: {
            ...mapActions('AdminsControl', ['createAdmins','updateAdmins','changeStatusAdmins']),
            ...mapMutations('AdminsControl', ['CLEAR_FORM']),
            
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true
                        
                        if(id){

                            this.updateAdmins(id).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Admins')
                                this.$emit('getAdmins');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Update Admin')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createAdmins().then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Admins')
                                this.$emit('getAdmins');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Added Admin')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
            _changeStatus: function(){
                var status = {
                    status: this.status,
                    users: this.del_admins
                }
                this.loading = true

                this.changeStatusAdmins(status).then(() => {
                    this.loading = false
                    this.status = '',
                    this.$emit('getAdmins');
                    this.$toast.success('Successfully Change Status Admin')
                    this.$bvModal.hide('modal-Status')
                }).catch((error) => {
                    console.log(error)
                    this.loading = false
                    this.$toast.warning('Sorry, Something Error')
                })
            },
        }
    }
</script>
